const constants = {
    APP_VERSION: "1.0.0.0"
}

export const appConstants = constants;
